import { $http } from '../component-base/xhr';
import localCache from '../../../utils/cache';
import { getUrlParam } from '../../utils/url';

export const STORAGE_KEY = 'user_search_record';
const MAX_SIZE = 20;
const entranceId = Number(getUrlParam('entranceId')) || 1;

export function getSearchRecord(STORAGE_KEY) {
    let searchRecordList = [];
    try {
        searchRecordList = JSON.parse(localCache.get(STORAGE_KEY) || '') || [];
    } catch (e) {
        // skip
    }
    return searchRecordList;
}

export function setSearchRecord(key, STORAGE_KEY) {
    let searchRecordList = [];
    try {
        searchRecordList = JSON.parse(localCache.get(STORAGE_KEY) || '') || [];
    } catch (e) {
        // skip
    }
    // 过滤重复记录
    searchRecordList = searchRecordList.filter(searchRecord => {
        return searchRecord.value !== key;
    });
    if (key) {
        if (searchRecordList.length === MAX_SIZE) {
            searchRecordList.pop();
        }
        const id = (searchRecordList.length && searchRecordList[0].id ? searchRecordList[0].id : 0) + 1;
        searchRecordList.unshift({
            id,
            value: key,
        });
    }

    try {
        localCache.set(STORAGE_KEY, JSON.stringify(searchRecordList));
    } catch (e) {
        // skip
    }

    const data = getSearchRecord(STORAGE_KEY);
    return data;
}

export function removeSearchRecord(STORAGE_KEY) {
    localCache.remove(STORAGE_KEY);
}

export async function fetchUserDetail(params) {
    const res = await $http.post('/rest/csc/center/user/get', {
        ...params,
        entranceId,
    });
    return res.data;
}

export async function fetchUserList(params) {
    const res = await $http.post('/rest/csc/center/user/search', {
        ...params,
        entranceId,
    });
    return res.data;
}